"use client";
import "@/styles/home/servicecards.css";
import Link from "next/link";
import Image from "next/image";

import { twMerge } from "tailwind-merge";

import { useIsDark } from "@/context/ThemeContext";

export default function ServicesCard({ icon, name, alt, href }) {
  const isdark = useIsDark();
  return (
    <Link href={href}>
      <div
        className={
          "relative w-full aspect-[280/200] rounded-[10px] border border-transparent hover:border-[#FF1CF766] hover:shadow-[0_4px_4px_#FF1CF733] transition-all duration-100 overflow-hidden"
        }
      >
        <Image
          src={icon}
          alt={alt || name}
          fill
          sizes="(max-width: 639px) 50vw, (max-width: 1023px) 25vw, 350px"
          quality={75}
          placeholder={typeof icon === "string" ? undefined : "blur"}
          className="object-cover rounded-[10px]"
        />
        <div
          className={twMerge(
            "absolute inset-0 rounded-[10px]",
            isdark ? "bg-[#000000B2]" : "bg-[#00000066]"
          )}
        ></div>
        <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[195px] font-manrope font-bold text-[14px] mobile:text-[16px] tablet:text-[18px] lg:text-[20px] xl:text-[22px] 3xl:text-[26px] 4xl:text-[30px] tracking-[0.02em] xl:leading-[34px] text-[#FFFFFF] text-center z-20">
          {name}
        </p>
      </div>
    </Link>
  );
}
